module.exports = __webpack_public_path__ + "static/black_gauntlet_of_bane-ec60765672c50069d6341322222562cf.jpeg";